import React from "react";
import styles from "./sobre_mim_wedson_rodrigues_.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_wedson_rodrigues_: React.FC = () => {

    return (
        <div className={styles.sobre_mim_wedson_rodrigues_}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/wedson_rodrigues_" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Wedson Rodrigues" />
                </div>
                <h2>Wedson Rodrigues</h2>
                <p>
                    Desde criança, o desenho foi meu refúgio e a forma mais sincera que encontrei de me expressar. Vindo de uma realidade simples, aprendi cedo que nada vem de graça — e que a arte pode ser uma ponte entre o sonho e a conquista.
                </p>
                <p>
                    A tatuagem entrou na minha vida como curiosidade e se transformou em propósito. Hoje, depois quase 10 anos de dedicação, estudo e experiência, entendo que tatuar vai muito além da técnica — é sobre eternizar histórias, sentimentos e fases da vida em forma de arte.
                </p>
                <p>
                    No meu trabalho, busco unir sensibilidade e precisão em cada projeto, valorizando a personalidade e o significado por trás de cada traço. Me especializei em estilos que me permitem expressar diferentes emoções e texturas visuais — como o neotradicional, o realismo preto e branco, o fine line e outros estilos que me desafiam a evoluir constantemente.
                </p>
                <p>
                    Minha missão com cada cliente é criar uma experiência verdadeira, onde confiança, arte e identidade caminham juntas. Mais do que uma tatuagem, quero entregar algo que carregue propósito, beleza e autenticidade — porque acredito que cada pessoa tem uma história digna de ser marcada na pele.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5517992176906?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/Q7x2Qq3FkowMMJzd7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/wedson.rodrigues_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_wedson_rodrigues_;
